import React from "react";
import { Col, Form } from "react-bootstrap";

function OtherPlace({
  data,
  setData,
  subStructureResourceHandleChange,
  main_index,
  sub_index,
  isEdit,
  item
}) {
  console.log("OtherPlace",item);
  return (
    <>
      <Col md={2}>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>
            {!isEdit && <label
              className="text-danger"
              style={{ cursor: "pointer" }}
              onClick={() => {
                let updateData = { ...data };
                updateData.third.structure_resource[main_index].data.splice(
                  sub_index,
                  1
                );
                setData(updateData);
              }}
            >
              X
            </label>}{" "}
            {sub_index + 1}. ชื่อสถานที่
          </Form.Label>
          <Form.Control
            type="text"
            name="resource_name"
            value={
              data.third.structure_resource[main_index].data[sub_index]
                .resource_name
            }
            onChange={(e) =>
              subStructureResourceHandleChange(e, main_index, sub_index)
            }
          />
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>รายละเอียดสถานที่ (ถ้ามี)</Form.Label>
          <Form.Control
            type="text"
            name="detail"
            value={
              item.detail
            }
            onChange={(e) =>
              subStructureResourceHandleChange(e, main_index, sub_index)
            }
          />
        </Form.Group>
      </Col>
      <Col md={2}>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>ปีที่ก่อตั้งขึ้น (พ.ศ.)</Form.Label>
          <Form.Control
            type="number"
            name="resource_year"
            min="1000"
            value={
              data.third.structure_resource[main_index].data[sub_index]
                .resource_year
            }
            onChange={(e) =>
              subStructureResourceHandleChange(e, main_index, sub_index)
            }
          />
        </Form.Group>
      </Col>
      <Col md={2}>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>ตำแหน่งที่ตั้ง</Form.Label>
          <Form.Control
            type="text"
            name="resource_address"
            placeholder="รายละเอียดคร่าว ๆ"
            value={
              data.third.structure_resource[main_index].data[sub_index]
                .resource_address
            }
            onChange={(e) =>
              subStructureResourceHandleChange(e, main_index, sub_index)
            }
          />
        </Form.Group>
      </Col>
      <Col md={2}>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>ละติจูด</Form.Label>
          <Form.Control
            type="number"
            name="latitude"
            placeholder=""
            value={
              data.third.structure_resource[main_index].data[sub_index].latitude
            }
            onChange={(e) =>
              subStructureResourceHandleChange(e, main_index, sub_index)
            }
          />
        </Form.Group>
      </Col>
      <Col md={2}>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>ลองจิจูด</Form.Label>
          <Form.Control
            type="number"
            name="longitude"
            placeholder=""
            value={
              data.third.structure_resource[main_index].data[sub_index]
                .longitude
            }
            onChange={(e) =>
              subStructureResourceHandleChange(e, main_index, sub_index)
            }
          />
        </Form.Group>
      </Col>
    </>
  );
}

export default OtherPlace;
